export const API_URL = process.env.REACT_APP_API_URL || 'https://homzy-site-backend.onrender.com';
export const API_BASE_URL = `${API_URL}/api`;
